<div class="misc-wrapper">
    <h1 class="mb-2 mx-2" style="line-height: 6rem; font-size: 6rem">404</h1>
    <h4 class="mb-2 mx-2">Page Not Found️ ⚠️</h4>
    <p class="mb-6 mx-2">we couldn't find the page you are looking for</p>
    <a routerLink="/system/home" class="btn btn-primary mb-10">Back to home</a>
</div>